import { defaultEventTypesValues } from '../constants/event-types'
import { WebhookSubscriptionInterface } from '../types/webhook-settings-interface'

export const getCheckedEventTypes = (subscriptions: WebhookSubscriptionInterface[]) =>
  subscriptions.reduce(
    (acc, next) => {
      if (next.disabledReason) return acc

      acc[next.event] = true
      return acc
    },
    { ...defaultEventTypesValues },
  )
